import { SiteFacade } from './site/site.facade';
import { PagesFacade } from './pages/pages.facade';
import { ContentFacade } from './content/content.facade';
import { SettingsFacade } from './settings/settings.facade';
import { PageSettingsFacade } from './page-settings/page-settings.facade';
import { DomainsFacade } from './domains/domains.facade';
import { ProductCatalogFacade } from './product-catalog/product-catalog.facade';

export const WebsiteFacades = [
    SiteFacade,
    PagesFacade,
    ContentFacade,
    SettingsFacade,
    PageSettingsFacade,
    DomainsFacade,
    ProductCatalogFacade,
];
